<template>
    <div class="page"
        v-for="(groups, page) in splitToPages((project.groups.length > project.zones.length ? project.groups : project.tasks), project.groups.length > project.zones.length ? 6 : 15, project.groups.length > project.zones.length ? 5 : 15)">
        <div class="formgrid grid">
            <div class="field col-12 md:col-12" style="margin-bottom:5px;font-weight: bold;" v-if="page == 0">
                {{ title }}
            </div>
            <div v-if="getTotalDays <= 31" class="field col-12 md:col-12">
                <table class="table" id="gantt">
                    <tr>
                        <th></th>
                        <template
                            v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                            <th
                                :colspan="getDaysBetweenDates(project.commencementDate, project.completionDate).filter(d => d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth()).length">
                                {{ month.getFullYear() }}/{{ month.getMonth() + 1 }}
                            </th>
                        </template>
                    </tr>
                    <tr>
                        <th style="font-size:12px">Contrction Activity</th>
                        <template
                            v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                            <template
                                v-for="day in getDaysBetweenDates(project.commencementDate, project.completionDate).filter(d => d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth())">
                                <th style="text-align: center;">{{ day.getDate().toString().padStart(2, '0') }}
                                </th>
                            </template>
                        </template>
                    </tr>
                    <template v-for="zone in project.zones">
                        <tr v-if="groups.filter(g => g.zone == zone.id).length > 0">
                            <td style="font-weight:bold">{{ zone.name }}</td>
                            <template
                                v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                                <template
                                    v-for="day in getDaysBetweenDates(project.commencementDate, project.completionDate).filter(d => d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth())">
                                    <td></td>
                                </template>
                            </template>
                        </tr>
                        <template v-for="group in groups.filter(g => g.zone == zone.id)">
                            <tr>
                                <td>{{ group.name }}</td>
                                <template
                                    v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                                    <template
                                        v-for="day in getDaysBetweenDates(project.commencementDate, project.completionDate).filter(d => d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth())">
                                        <td v-if="getDate(group.start).setHours(0) <= day && day <= getDate(group.end) && isDateBetweenDates(new Date(month.getFullYear(), month.getMonth() + 1, 1), start, end)"
                                            class="darkgreyCell">
                                        </td>
                                        <td v-if="getDate(group.start).setHours(0) <= day && day <= getDate(group.end)"
                                            class="greyCell">
                                        </td>
                                        <td v-else></td>
                                    </template>
                                </template>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
            <div v-else-if="getTotalMonths <= 6" class="field col-12 md:col-12">
                <table class="table" id="gantt">
                    <tr>
                        <th></th>
                        <template
                            v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(month => getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(w => w.getFullYear() === month.getFullYear() && w.getMonth() === month.getMonth()).length)">
                            <th
                                :colspan="getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(w => w.getFullYear() === month.getFullYear() && w.getMonth() === month.getMonth()).length">
                                {{ month.getFullYear() }}/{{ month.getMonth() + 1 }}
                            </th>
                        </template>
                    </tr>
                    <tr>
                        <th>Contrction Activity</th>
                        <template
                            v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(month => getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(w => w.getFullYear() === month.getFullYear() && w.getMonth() === month.getMonth()).length)">
                            <template
                                v-for="day in getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(w => w.getFullYear() === month.getFullYear() && w.getMonth() === month.getMonth())">
                                <th style="text-align: center;">{{ day.getDate().toString().padStart(2, '0') }}
                                </th>
                            </template>
                        </template>
                    </tr>
                    <template v-for="zone in project.zones">
                        <tr v-if="groups.filter(g => g.zone == zone.id).length > 0">
                            <td style="font-weight:bold">{{ zone.name }}</td>
                            <template
                                v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                                <template
                                    v-for="day in getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(d => d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth())">
                                    <td></td>
                                </template>
                            </template>
                        </tr>
                        <template v-for="group in groups.filter(g => g.zone == zone.id)">
                            <tr>
                                <td>{{ group.name }}</td>
                                <template
                                    v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate)">
                                    <template
                                        v-for="day in getWeeksBetweenDates(project.commencementDate, project.completionDate).filter(w => w.getFullYear() === month.getFullYear() && w.getMonth() === month.getMonth())">
                                        <td v-if="getDate(group.start).setHours(0) <= day && day <= getDate(group.end) && isDateBetweenDates(new Date(month.getFullYear(), month.getMonth() + 1, 1), start, end)"
                                            class="darkgreyCell">
                                        </td>
                                        <td v-else-if="getDate(group.start).setHours(0) <= day && day <= getDate(group.end)"
                                            class="greyCell">
                                        </td>
                                        <td v-else></td>
                                    </template>
                                </template>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
            <div v-else class="field col-12 md:col-12">
                <table class="table" id="gantt">
                    <tr>
                        <th></th>
                        <template v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                            <th
                                :colspan="getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear()).length">
                                {{
                                    year.getFullYear()
                                }}</th>
                        </template>
                    </tr>
                    <tr>
                        <th>Contrction Activity</th>
                        <template v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                            <template
                                v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear())">
                                <th style="text-align: center;">{{ (month.getMonth() + 1).toString().padStart(2,
                                    '0')
                                    }}
                                </th>
                            </template>
                        </template>
                    </tr>
                    <template v-for="zone in project.zones">
                        <tr v-if="groups.filter(g => g.zone == zone.id).length > 0">
                            <td style="font-weight:bold">{{ zone.name }}</td>
                            <template
                                v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                                <template
                                    v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear())">
                                    <td></td>
                                </template>
                            </template>
                        </tr>
                        <template v-for="group in groups.filter(g => g.zone == zone.id)">
                            <tr>
                                <td>{{ group.name }}</td>
                                <template
                                    v-for="year in getYearBetweenDates(project.commencementDate, project.completionDate)">
                                    <template
                                        v-for="month in getMonthsBetweenDates(project.commencementDate, project.completionDate).filter(m => m.getFullYear() === year.getFullYear())">
                                        <td v-if="getDate(group.start).setHours(0) < new Date(month.getFullYear(), month.getMonth() + 1, 1) && month <= getDate(group.end) && isDateBetweenDates(new Date(month.getFullYear(), month.getMonth() + 1, 1), start, end)"
                                            class="darkgreyCell">
                                        </td>
                                        <td v-else-if="getDate(group.start).setHours(0) < new Date(month.getFullYear(), month.getMonth() + 1, 1) && month <= getDate(group.end)"
                                            class="greyCell">
                                        </td>
                                        <td v-else></td>
                                    </template>
                                </template>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
            <div class="formgrid grid" v-if="start && end" style="width:100%;margin-left: 10px;">
                <div class="field col-12 md:col-1 darkgreyCell">
                </div>
                <div class="field col-12 md:col-11">
                    {{ legend }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputLabel from "./InputLabel.vue"
import DropdownLabel from "./DropdownLabel.vue"
import DateHelper from "@/helper/DateHelper"
export default {
    name: 'Appendix',
    props: {
        project: Object,
        title: String,
        legend: String,
        start: Array,
        end: Array
    },
    computed: {
        getTotalDays() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24)
        },
        getTotalWeeks() {
            return (DateHelper.getDate(this.project.completionDate).getTime() - DateHelper.getDate(this.project.commencementDate).getTime()) / (1000 * 3600 * 24 * 7)
        },
        getTotalMonths() {
            let d1 = DateHelper.getDate(this.project.commencementDate);
            let d2 = DateHelper.getDate(this.project.completionDate);
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
    },
    methods: {
        getDateString(date) {
            return DateHelper.getDateString(date);
        },
        getDaysBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var days = [];
            while (start <= end) {
                days.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 1);
            }
            return days;
        },
        getWeeksBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var weeks = [];
            while (start <= end) {
                weeks.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                start.setDate(start.getDate() + 7);
            }
            return weeks;
        },
        getMonthsBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), start.getMonth(), 1);
            var months = [];
            while (date <= new Date(end.getFullYear(), end.getMonth(), 1)) {
                months.push(new Date(date.getFullYear(), date.getMonth(), 1));
                date.setMonth(date.getMonth() + 1);
            }
            return months;
        },
        getYearBetweenDates(start, end) {
            start = DateHelper.getDate(start);
            end = DateHelper.getDate(end);
            var date = new Date(start.getFullYear(), 0, 1);
            var years = [];
            while (date <= new Date(end.getFullYear(), 0, 1)) {
                years.push(new Date(date.getFullYear(), 0, 1));
                date.setYear(date.getFullYear() + 1);
            }
            return years;
        },
        getDate(date) {
            return DateHelper.getDate(date)
        },
        isDateBetweenDates(target, start, end) {
            if (!start || !end) return false;
            start = start.map(d => DateHelper.getDate(d));
            end = end.map(d => DateHelper.getDate(d));
            target = DateHelper.getDate(target);
            let result = false;
            for (var i = 0; i < start.length; i++) {
                result = result || (target >= start[i] && target <= end[i]);
            }
            return result;
        },
        splitToPages(list, firstPageCount, otherPageCount) {
            let pages = []
            let sublist = [];
            for (var i = 0; i < list.length; i++) {
                if ((i + 1 - firstPageCount) % otherPageCount == 0) {
                    sublist.push(list[i])
                    pages.push(sublist);
                    sublist = [];
                }
                else {
                    sublist.push(list[i])
                }
            }
            if (sublist.length > 0) {
                pages.push(sublist);
            }
            return pages;
        },
        numberToLetter(num) {
            var s = '';
            var t;
            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s;
        },
        getCombinationString(combination) {
            return combination.split('+').map(c => this.numberToLetter(this.project.tasks.indexOf(this.project.tasks.filter(t => t.id == c.split("-")[1])[0]) + 1)).sort().join('+');
        }
    },
    mounted() {
    },
    components: {
        InputLabel,
        DropdownLabel
    }
}
</script>

<style lang="less" scoped>
.appendix {
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}

.center {
    text-align: center;
    width: 100%;
}

.page {
    width: 100%;
    height: auto;
    aspect-ratio: 841.89 / 595.28;
    padding: 20px 25px;
}

.cover {
    text-align: right;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    width: 90%;
}

.table {
    width: 100%;
    font-size: 12px;
    margin-bottom: 10px;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td {
    padding: 3px
}

.header {
    text-align: center;
    width: 100%;
}

.header>th {
    background-color: rgb(172, 172, 172);
    font-size: 12px;
}

.sub-header {
    text-align: center;
    font-weight: bold;
}

.cell {
    width: 100%;
}

.greyCell {
    background-color: rgb(172, 172, 172);
}

.darkgreyCell {
    background-color: rgb(91, 91, 91);
}


#gantt>tr>td:first-child {
    width: 33%;
}

.number {
    text-align: center
}
</style>